import React, { useEffect, useState } from 'react';
import { Box, Skeleton } from '@mui/material';
import { colors } from '../theme/theme';

interface CardImageWithPlaceholderProps {
  src?: string | null;
  alt: string;
  height?: number;
  borderRadius?: string;
  fallback?: React.ReactNode;
}

const CardImageWithPlaceholder: React.FC<CardImageWithPlaceholderProps> = ({
  src,
  alt,
  height = 160,
  borderRadius = '8px 8px 0 0',
  fallback,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setLoaded(false);
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return (
      <Box
        sx={{
          width: '100%',
          height,
          borderRadius,
          bgcolor: colors.backgroundTertiary,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: colors.textSecondary,
        }}
      >
        {fallback}
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative', width: '100%', height, borderRadius, overflow: 'hidden' }}>
      {!loaded && (
        <Skeleton
          animation="wave"
          variant="rectangular"
          width="100%"
          height={height}
          sx={{ position: 'absolute', inset: 0, borderRadius }}
        />
      )}
      <Box
        component="img"
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => setFailed(true)}
        sx={{
          width: '100%',
          height,
          objectFit: 'cover',
          display: 'block',
          opacity: loaded ? 1 : 0,
          transition: 'opacity 0.2s ease',
        }}
      />
    </Box>
  );
};

export default CardImageWithPlaceholder;
